export default function formatDate(data: Date | null){
    let data2 = data!.toString().split('Z')[0]
    console.log(new Date(`${data2}`).toLocaleDateString() + ' ' + new Date(`${data2}`).toLocaleTimeString().split(':').slice(0,2).join(':'))
    return new Date(`${data2}`).toLocaleDateString() + ' ' + new Date(`${data2}`).toLocaleTimeString().split(':').slice(0,2).join(':')
}